import script from "./Assignee.vue?vue&type=script&setup=true&lang=js"
export * from "./Assignee.vue?vue&type=script&setup=true&lang=js"

import "./Assignee.vue?vue&type=style&index=0&id=6d4f6718&lang=css"

const __exports__ = script;

export default __exports__